import React, { PureComponent } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { fetchStep } from '../../../redux/reducers/module';
// components
import StepTitle from './StepTitle';
// utils
import get from 'lodash.get';
// styles
import styles from './SummaryStep.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class SummaryStep extends PureComponent {
  componentDidMount() {
    const { data, fetchStep } = this.props;
    fetchStep(data.id);
  }

  render() {
    const {
      data: { title, description, content }
    } = this.props;
    const data = get(content, 'content', []);

    return (
      <div className={cn('wrapper')}>
        <StepTitle title={title} description={description} />
        {data.map(({ title, value }) => (
          <div className={cn('item')} key={title}>
            <span className={cn('item-title')}>{title}</span>
            <span className={cn('item-value')}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
}

SummaryStep.propTypes = {
  fetchStep: T.func.isRequired,
  data: T.shape({
    id: T.number.isRequired,
    title: T.string.isRequired,
    content: T.shape({
      content: T.arrayOf(
        T.shape({
          title: T.string.isRequired,
          value: T.oneOfType([T.string, T.number]).isRequired
        })
      )
    }).isRequired
  })
};

const withConnect = connect(
  state => ({
    isStepLoading: state.module.isLoading
  }),
  { fetchStep }
);

export default withConnect(SummaryStep);



// WEBPACK FOOTER //
// ./src/containers/Module/components/SummaryStep.jsx